import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { StudySubscription } from 'src/app/models/subscription';

export const getSubscription = createAction('[Subscription] Get Subscription', props<{ studyId: number }>());

export const getSubscriptionSuccess = createAction(
  '[Subscription] Get Subscription Success',
  props<{ fetchedSubscription: StudySubscription }>()
);

export const getSubscriptionError = createAction(
  '[Subscription] Get Subscription Error',
  props<{ err: HttpErrorResponse }>()
);

export const updateSubscription = createAction(
  '[Subscription] Update Subscription',
  props<{ subscription: StudySubscription }>()
);

export const updateSubscriptionSuccess = createAction(
  '[Subscription] Update Subscription Success',
  props<{ updatedSubscription: StudySubscription }>()
);

export const updateSubscriptionError = createAction(
  '[Subscription] Update Subscription Error',
  props<{ err: HttpErrorResponse }>()
);
